import styled from 'styled-components'

export const WrapperContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => `rgb(${theme.background.modal})`};
  min-width: 20rem;
  max-width: 50.62rem;
  max-height: 30rem;
  border-radius: 6px;
  padding: 1rem;

  hr {
    display: none;
  }

  form {
    width: 100%;
    margin-bottom: 1rem;
  }

  p {
    width: auto;
    font-size: 14px;
    text-align: justify;
    padding-right: 0.3rem;
    line-height: 140%;
    overflow: auto;
    ::-webkit-scrollbar {
      height: 0px;
      width: 3px;
    }
  }
  textarea {
    min-width: 20.4rem;
    min-height: 10rem;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
  }
  @media only screen and (min-width: 800px) {
    hr {
      display: flex;
      width: auto;
      height: 2px;
      margin: 0.5rem 0;
      opacity: 0.25;
    }

    form {
      #line-two {
        display: flex;
        width: 100%;
        height: 2px;
        margin: 1rem 0;
        opacity: 0.25;
      }
    }
  }
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 18rem;
  max-width: 60rem;
  font-weight: bold;

  button {
    border: none;
    background-color: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }
`

export const FooterAnnotation = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  border: none;
  margin-top: 1rem;
`

export const TextNote = styled.div`
  width: 75%;
  border-radius: 5px;
  padding-left: 5px;
  h5 {
    color: ${({ theme }) => `rgb(${theme.primary.base})`};
  }

  b {
    font-weight: bolder;
  }
`

export const ButtonsAnnotattion = styled.div`
  width: 100%;
  display: flex;
  border: none;
  justify-content: end;
  margin-top: 1rem;

  button {
    display: flex;
    justify-content: end;
    align-items: center;
    justify-content: center;
    width: 5.5rem;
    height: 2rem;
    border-radius: 5px;
    border: solid 0.1px ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    background-color: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
  }
  .save-button {
    margin-left: 0.7rem;
    border-radius: 5px solid;
    background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
    color: ${({ theme }) => `rgb(${theme.background.high})`};
    border: none;
    font-weight: 700;
  }
`
